import { combineReducers } from 'redux';
import { newsReducer } from '../app/news/duck';
import { singleNewsReducer } from '../app/single-article/single-news/duck';
import { reviewsReducer } from '../app/reviews/duck';
import { singleReviewReducer } from '../app/single-article/single-review/duck';
import { t3Reducer } from '../app/how-to-(T3)/duck';
import { singleT3Reducer } from '../app/single-article/single-t3/duck';
import { internetReducer } from '../app/internet/duck';
// import { bestOfReducer } from '../app/best-of/duck';
// import { singleBestOfReducer } from '../app/single-article/single-best-of/duck';
import { authorInfoReducer } from '../app/author/duck';
import { tagsPostListReducer } from '../app/tags/duck';
import { homeReducer } from '../app/home/duck';
import { galleryReducer } from '../app/gallery/duck';
import { searchReducer } from '../app/common/Search/duck/reducers';

const rootReducer = combineReducers({
  news: newsReducer,
  singleNews: singleNewsReducer,
  reviews: reviewsReducer,
  singleReview: singleReviewReducer,
  t3: t3Reducer,
  singleT3: singleT3Reducer,
  internet: internetReducer,
  // bestOf: bestOfReducer,
  // singleBestOf: singleBestOfReducer,
  authorInfo: authorInfoReducer,
  tagsPostList: tagsPostListReducer,
  home: homeReducer,
  gallery: galleryReducer,
  search: searchReducer
});

export default rootReducer;
